const cxgjts = [{
  path: 'gjts_pglb',
  name: 'gjts_pglb',
  component: () =>
        import('@/components/cxgjts/pglb'),
  meta: { title: '评估列表', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'gjts_pgjl',
  name: 'gjts_pgjl',
  component: () =>
        import('@/components/cxgjts/pgjl'),
  meta: { title: '评估记录', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'gjts_gxws',
  name: 'gjts_gxws',
  component: () =>
        import('@/components/cxgjts/gxws'),
  meta: { title: '更新完善', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'gjts_gxwslb',
  name: 'gjts_gxwslb',
  component: () =>
        import('@/components/cxgjts/gxwslb'),
  meta: { title: '更新完善列表', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'gjts_gxwsjl',
  name: 'gjts_gxwsjl',
  component: () =>
        import('@/components/cxgjts/gxwsjl'),
  meta: { title: '更新完善记录', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'gjts_fxwt',
  name: 'gjts_fxwt',
  component: () =>
        import('@/components/cxgjts/fxwt'),
  meta: { title: '发现问题', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'gjts_zgwt',
  name: 'gjts_zgwt',
  component: () =>
        import('@/components/cxgjts/zgwt'),
  meta: { title: '整改问题', requireAuth: true, keepAlive: true, permission: true }
}, {
  path: 'gjts_zgjl',
  name: 'gjts_zgjl',
  component: () =>
        import('@/components/cxgjts/zgjl'),
  meta: { title: '整改记录', requireAuth: true, keepAlive: true, permission: true }
} ]
export default cxgjts



// WEBPACK FOOTER //
// ./src/router/cxgjts.js